import styles from "./ClientAddress.module.css";

import editIcon from "../../assets/editIcon.svg";
import removeIcon from "../../assets/removeIcon.svg";

import {Link} from "react-router-dom";

import {ClientAddressType} from "../ClientListAddress";

import {useTranslation} from "react-i18next";

interface ClientAddressProps {
  addressInfo: ClientAddressType;
  handleRemove: (id: string) => void;
}

const ClientAddress = ({ addressInfo, handleRemove }: ClientAddressProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles.mainContainer}>
      <h3>{addressInfo.name ?? t(`accountMenu.noAddressName`)}</h3>
      <p>{`${addressInfo.street}, ${addressInfo.district} ${addressInfo.number}`}</p>
      {addressInfo.complement && <p>{addressInfo.complement}</p>}
      <p>{`${addressInfo.city}, ${addressInfo.state} ${addressInfo.zipCode}`}</p>
      <div className={styles.buttonsContainer}>
        <Link
          to={`/auth/client/account/addresses/edit/${addressInfo.id}`}
          className={styles.editIconLink}
          style={{ backgroundImage: `url(${editIcon})` }}
        />
        <button
          type="button"
          className={styles.removeIconLink}
          style={{ backgroundImage: `url(${removeIcon})` }}
          onClick={() => handleRemove(addressInfo.id)}
        ></button>
      </div>
    </div>
  );
};

export default ClientAddress;
